import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class DisallowedValueCommand extends AbstractConfDataCommand {
  confValueId: number;
  paramValueId?: number;
}